// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.inbox-img[data-v-352e26fc] {\n  width: 200px;\n  height: 200px;\n  margin: 20px 0;\n  text-align: center;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  -webkit-background-size: cover;\n  background-size: cover;\n}\n.modal-img[data-v-352e26fc] {\n  text-align: center;\n  max-width: 100%;\n  max-height: 80vh;\n}\n.gallery-img[data-v-352e26fc] {\n  max-width: 100%;\n  margin: 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
